import { Box, Drawer, IconButton, Skeleton } from '@mui/material';
import { IoClose } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid2';

export default function DataSetFormSkeleton() {
  const navigate = useNavigate();

  return (
    <Drawer
      anchor='right'
      open={true}
      onClose={() => navigate(-1)}
      sx={{
        '& .MuiDrawer-paper': {
          width: { xs: '100%', sm: 600 },
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          zIndex: 100001
        }
      }}
    >
      {/* Fixed Header Skeleton */}
      <Box
        sx={{
          px: 3,
          py: 2,
          borderBottom: '1px solid #DEDEDE',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexShrink: 0
        }}
      >
        <Skeleton variant='text' width={120} height={32} />
        <IconButton onClick={() => navigate(-1)} size='small'>
          <IoClose size={24} />
        </IconButton>
      </Box>

      {/* Form Content Skeleton */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {/* Scrollable Content Skeleton */}
        <Box
          sx={{
            flex: 1,
            overflow: 'auto',
            p: 3
          }}
        >
          <Grid container spacing={3} alignItems='center'>
            {/* Name Field */}
            <Grid size={12}>
              <Skeleton variant='text' width={60} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' height={56} sx={{ borderRadius: 1 }} />
            </Grid>

            {/* Chunk Method Selector */}
            <Grid size={4}>
              <Skeleton variant='text' width={100} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' height={56} sx={{ borderRadius: 1 }} />
            </Grid>

            {/* Chunk Token Number Field */}
            <Grid size={4}>
              <Skeleton variant='text' width={140} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' height={56} sx={{ borderRadius: 1 }} />
            </Grid>

            {/* Delimiter Field */}
            <Grid size={4}>
              <Skeleton variant='text' width={80} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' height={56} sx={{ borderRadius: 1 }} />
            </Grid>

            {/* Layout Recognize Switch */}
            <Grid size={4}>
              <Box display='flex' alignItems='center' gap='4px'>
                <Skeleton variant='text' width={120} height={20} />
                <Skeleton variant='rectangular' width={50} height={30} sx={{ borderRadius: '15px' }} />
                <Skeleton variant='rectangular' width={20} height={20} sx={{ borderRadius: '50%' }} />
              </Box>
            </Grid>

            {/* Use Raptor Switch */}
            <Grid size={4}>
              <Box display='flex' alignItems='center' gap='4px'>
                <Skeleton variant='text' width={100} height={20} />
                <Skeleton variant='rectangular' width={50} height={30} sx={{ borderRadius: '15px' }} />
                <Skeleton variant='rectangular' width={20} height={20} sx={{ borderRadius: '50%' }} />
              </Box>
            </Grid>

            {/* Raptor Configuration Section */}
            <Grid container spacing={3}>
              {/* Raptor Prompt */}
              <Grid size={12}>
                <Skeleton variant='text' width={60} height={20} sx={{ mb: 1 }} />
                <Skeleton variant='rectangular' height={100} sx={{ borderRadius: 1 }} />
              </Grid>

              {/* Raptor Parameters Grid */}
              <Grid container spacing={3}>
                <Grid size={3}>
                  <Skeleton variant='text' width={80} height={20} sx={{ mb: 1 }} />
                  <Skeleton variant='rectangular' height={56} sx={{ borderRadius: 1 }} />
                </Grid>
                <Grid size={3}>
                  <Skeleton variant='text' width={80} height={20} sx={{ mb: 1 }} />
                  <Skeleton variant='rectangular' height={56} sx={{ borderRadius: 1 }} />
                </Grid>
                <Grid size={3}>
                  <Skeleton variant='text' width={90} height={20} sx={{ mb: 1 }} />
                  <Skeleton variant='rectangular' height={56} sx={{ borderRadius: 1 }} />
                </Grid>
                <Grid size={3}>
                  <Skeleton variant='text' width={100} height={20} sx={{ mb: 1 }} />
                  <Skeleton variant='rectangular' height={56} sx={{ borderRadius: 1 }} />
                </Grid>
              </Grid>
            </Grid>

            {/* File Upload Section */}
            <Grid size={12}>
              <Box border='1px solid #F3F3F3' borderRadius={1} p={2}>
                <Skeleton variant='text' width={120} height={24} sx={{ mb: 2 }} />

                {/* Upload Area */}
                <Box border='2px dashed #e0e0e0' borderRadius={1} p={3} textAlign='center' mb={2}>
                  <Skeleton variant='rectangular' width={60} height={60} sx={{ borderRadius: 1, mx: 'auto', mb: 1 }} />
                  <Skeleton variant='text' width={200} height={20} sx={{ mx: 'auto', mb: 0.5 }} />
                  <Skeleton variant='text' width={150} height={16} sx={{ mx: 'auto' }} />
                </Box>

                {/* File List */}
                <Box>
                  {[...Array(3)].map((_, index) => (
                    <Box key={index} display='flex' alignItems='center' gap={2} mb={1}>
                      <Skeleton variant='rectangular' width={20} height={20} sx={{ borderRadius: 0.5 }} />
                      <Skeleton variant='text' width={200} height={20} />
                      <Skeleton variant='text' width={80} height={16} />
                    </Box>
                  ))}
                </Box>
              </Box>
            </Grid>

            {/* URL Input (for website type) */}
            <Grid size={12}>
              <Skeleton variant='text' width={40} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' height={56} sx={{ borderRadius: 1 }} />
            </Grid>
          </Grid>
        </Box>

        {/* Fixed Footer Skeleton */}
        <Box
          sx={{
            px: 3,
            py: 2,
            borderTop: '1px solid #DEDEDE',
            display: 'flex',
            justifyContent: 'end',
            gap: 2,
            flexShrink: 0
          }}
        >
          <Skeleton variant='rectangular' width={80} height={40} sx={{ borderRadius: 1 }} />
          <Skeleton variant='rectangular' width={100} height={40} sx={{ borderRadius: 1 }} />
        </Box>
      </Box>
    </Drawer>
  );
}
